import { type GameProgress } from '@/shared/api/game/types';

export enum Method {
  AL_NEW_PAYMENT = 'sendAnalyticNewPayment',
  AL_NEW_SESSION = 'sendAnalyticNewSession',
  BACK_BUTTON_CLICKED = 'backButtonClicked',
  BACK_BUTTON_HIDE = 'backButtonHide',
  BACK_BUTTON_SHOW = 'backButtonShow',
  CLOSE_WEB_APP = 'closeWebapp',
  CUSTOM_SHARE = 'customShare',
  ERR_AD = 'errAd',
  GET_DATA = 'getData',
  GET_INIT_DATA = 'getInitData',
  GET_PAYMENT_INFO = 'getPaymentInfo',
  GET_PLATFORM = 'getPlatform',
  GET_PLAYDECK_STATE = 'getPlaydeckState',
  GET_SCORE = 'getScore',
  GET_SHARE_LINK = 'getShareLink',
  GET_TOKEN = 'getToken',
  GET_URL_PARAMS = 'getUrlParams',
  GET_USER = 'getUser',
  GET_USER_LOCALE = 'getUserLocale',
  GET_USER_PROFILE = 'getUserProfile',
  HAPTIC_FEEDBACK = 'hapticFeedback',
  INVOICE_CLOSED = 'invoiceClosed',
  IS_OPEN = 'isOpen',
  LOADED = 'loaded',
  LOADING = 'loading',
  NOT_FOUND_AD = 'notFoundAd',
  OPEN_LINK = 'openLink',
  OPEN_TG_LINK = 'openTelegramLink',
  PLAY = 'play',
  REPLAY = 'replay',
  REQUEST_PAYMENT = 'requestPayment',
  RESPOND_TRANSACTION_STATUS = 'respondTonTransactionStatus',
  RETURN_TO_MP = 'returnToMp',
  REWARDED_AD = 'rewardedAd',
  SEND_ANALYTICS = 'sendAnalytics',
  SEND_GAME_PROGRESS = 'sendGameProgress',
  SEND_TON_TRANSACTION = 'sendTonTransaction',
  SET_DATA = 'setData',
  SET_SCORE = 'setScore',
  SHARE_MESSAGE = 'shareMessage',
  SHOW_AD = 'showAd',
  SHOW_AD_BANNER = 'showAdBanner',
  SHOW_SCORE = 'showScore',
  SKIP_AD = 'skipAd',
  START_AD = 'startAd',
}

export interface PlaydeckData {
  method: Method;
  value: any;
  isForce: boolean;
  userId: number;
  text: string;
  key: string;
  progress?: GameProgress;
}

export interface MessageData {
  playdeck: PlaydeckData;
}

export enum WrapperTheme {
  DEFAULT = 'default',
}
